// Copyright (C) 2019 TANNER AG

import React from "react";
import * as PropTypes from "prop-types";

const BUS_IMAGES = {
	"12C_CNG": require("../assets/12C_CNG.jpg"),
	"12C_Diesel": require("../assets/12C_Diesel.jpg"),
	"18C_CNG": require("../assets/18C_CNG.jpg"),
	"18C_Diesel": require("../assets/18C_Diesel.jpg"),
	"A21_CNG": require("../assets/A21_CNG.jpg"),
	"A21_Diesel": require("../assets/A21_Diesel.jpg"),
	"A23_CNG": require("../assets/A23_CNG.jpg"),
	"A23_Diesel": require("../assets/A23_Diesel.jpg")
};

export const BusImage = (props) => {
	const { type, fuel, name, ...others } = props;
	const imageName = `${type}_${fuel}`;

	if (!BUS_IMAGES.hasOwnProperty(imageName)) {
		return null;
	}

	return (
		<img
			src={BUS_IMAGES[imageName]}
			alt={name}
			{...others}
		/>
	);
};

BusImage.propTypes = {
	type: PropTypes.string,
	fuel: PropTypes.string,
	name: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/tco/components/busimage.js